export const API_KEY = "AIzaSyAnsy8oArTdYQ71xF6V7qFm0P5yCtbEzic";
export const  CONTEXT_KEY = "168fdc75d23e94117";

export default API_KEY;
